import React, {useState} from 'react';
import ls from 'local-storage';
import { ProSidebar, SidebarHeader, SidebarFooter, SidebarContent, MenuItem,Menu,SubMenu  } from 'react-pro-sidebar'
import './scss/styles.scss';

const Icon = (props)=>{
  return (
    <span className={props.name}> </span>
  );
};
function Sidebar (props){
  const isAdmin = (ls.get('admin')?true:false);
  const [collapsed,setCollapsed] = useState(true)
  const [actualActive, setActualActive] = useState('Ventas')
  function toogleCollapsed(){
    props.toggleCollapsed(!collapsed);
    setCollapsed(!collapsed);
  }
  function toggleActualActive(key){
    setActualActive(key);
    props.toggleOption(key);
    toogleCollapsed()
  }
  function isActive(id){
    if(id === actualActive){
      return true;
    }
    return false;
  }

  return (
    <ProSidebar collapsed={collapsed} collapsedWidth={50} width={200} style={{top:'5vh',position:'sticky',height: '95vh'}}>
      <SidebarHeader style={{backgroundColor:'#30333d',color:'white'}}>
        <Menu onClick={toogleCollapsed}>
          <MenuItem  icon={<Icon name="mdi mdi-menu"/>}>Cerrar Menu</MenuItem>
        </Menu>
      </SidebarHeader>
      <SidebarContent>
        <Menu innerSubMenuArrows={true}>
          <SubMenu title={'Reportes'} defaultOpen={true}>
            <MenuItem active={isActive('Ventas')} onClick={()=>{toggleActualActive('Ventas')}}>
              Ventas Proveedor vs Periodo
            </MenuItem>
          </SubMenu>
          {
            false?(
            <SubMenu title={'Administración'} defaultOpen={true}>
              <MenuItem active={isActive('admin_users')} onClick={()=>{toggleActualActive('admin_users')}}>
                Administracion de Usuarios
              </MenuItem>
              <MenuItem active={isActive('admin_users_profile')} onClick={()=>{toggleActualActive('admin_users_profile')}}>
                Administracion Perfil Usuarios
              </MenuItem>
            </SubMenu>
            ):(<></>)
          }
          
        </Menu>
      </SidebarContent>
      
      <SidebarFooter>
        <Menu>
        <MenuItem style={{margin:'-28px 0 -36px 13px'}}>
          <a href={'https://play.google.com/store/apps/details?id=com.gameplanet.marketplace'} rel="noreferrer" target={'_blank'}>
            <img alt={'android.png'}src={"./ios-android.png"} width={'150px'}></img>            
          </a>
        </MenuItem>
        </Menu>
        
        <Menu>
          <SubMenu icon={<Icon name="fa fa-cog"/>}  title={"Configuracion"} >
            <MenuItem icon={<Icon name="fa fa-user"/>} active={isActive('perfil')} onClick={()=>{toggleActualActive('perfil')}}>
              perfil
            </MenuItem>
            <MenuItem icon={<Icon name="fa fa-power-off"/>} active={isActive('logout')} onClick={()=>{toggleActualActive('logout')}}>
              Cerrar Sesión
            </MenuItem>
          </SubMenu>
        </Menu>
      </SidebarFooter>
  </ProSidebar>
  )
}
export default Sidebar;